import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ProductoDesembolso } from '../../../_models/producto-desembolso';
import { ProductoDesembolsoService } from '../../../_services/producto-desembolso.service';
import { NavService } from '../../../_services/_nav.service';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { Router } from '@angular/router';
import { Producto } from '../../../_models/producto';

@Component( {
  selector: 'app-producto-desembolso-listado',
  templateUrl: 'producto-desembolso-listado.component.html'
} )
export class ProductoDesembolsoListadoComponent implements OnInit {

  productosDesembolsos: ProductoDesembolso[] = [];
  carTabla = true;
  columnas: any[];
  columnas2: any[];
  busqueda: string;
  productoDesembolsoEdit: ProductoDesembolso;
  rangosMontosAprobados: any[] = [];
  verDetalle = false;
  @ViewChild('dt') tabla: Table;
  @Input() producto: Producto;
  editarProductoDesembolso = false;

  constructor( private productoDesembolsoService: ProductoDesembolsoService,
               private navServicio: NavService,
               private autServicio: AutenticacionService,
               private router: Router ) {
  }

  ngOnInit(): void {

    this.columnas = [
      { field: 'rango', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_RANGOMONTOAPROBADO' ), sort: false, colspan: 2 },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_RANGOPLAZOAPROBADO' ), sort: false, colspan: 2 },
      {
        field: 'fechaInicioVigencia',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_RANGOTASAPRODUCTO' ),
        sort: false,
        colspan: 2
      },
      {
        field: 'limiteDiaDesembolso',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_LIMITEDIADESEMBOLSO' ),
        sort: true,
        rowspan: 2
      },
      {
        field: 'nombreTipoCupo',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_CANTDESEMBOLSO' ),
        sort: false,
        colspan: 2
      },
      {
        field: 'nombreClasificacion',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_RANGOAPLICARPLAZO' ),
        sort: false,
        colspan: 2
      },
      {
        field: 'ampliarPlazo',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VECESAMPLIARPLAZO' ),
        sort: true,
        rowspan: 2
      },
      {
        field: 'diaMaximoMoraCliente',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_DIASMAXMORA' ),
        sort: true,
        rowspan: 2
      },
      {
        field: 'diaMaximoMoraProducto',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_DIASMAXMORAPRODUCTO' ),
        sort: true,
        rowspan: 2
      },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false, rowspan: 2 }
    ];
    this.columnas2 = [
      { field: 'rangoMontoAprobadoMinimo', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMINIMO' ), sort: true, },
      { field: 'rangoMontoAprobadoMaximo', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMAXIMO' ), sort: true },
      { field: 'rangoPlazoAprobadoMinimo', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMINIMO' ), sort: true, },
      { field: 'rangoPlazoAprobadoMaximo', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMAXIMO' ), sort: true },
      { field: 'rangoTasaProductoMinimo', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMINIMO' ), sort: true, },
      { field: 'rangoTasaProductoOrdinario', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMAXIMO' ), sort: true },
      {
        field: 'minimoDiaCantidadDesembolsoParcial',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMINIMO' ),
        sort: true
      },
      {
        field: 'maximoDiaCantidadDesembolsoParcial',
        header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMAXIMO' ),
        sort: true,
      },
      { field: 'rangoAmpliarPlazoMinimoDia', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMINIMO' ), sort: true, },
      { field: 'rangoAmpliarPlazoMaximoDia', header: this.navServicio.buscarMensaje( 'PRODUCTODESEMBOLSO.LBL_VALORMAXIMO' ), sort: true },
    ];
    this.busqueda = this.navServicio.getSearch( 'productoDesembolso.component' );
    this.productoDesembolsoService.listadoPorProducto( this.producto.idProducto ).subscribe( res => {
      this.productosDesembolsos = res;
      this.carTabla = false;
    } );
  }

  crear() {
    this.editar( { idProducto: this.producto.idProducto } as ProductoDesembolso );
  }

  setBusqueda() {
    this.navServicio.setSearch( 'productoDesembolso.component', this.busqueda );
  }

  ver( productoDesembolso: ProductoDesembolso ) {
    this.productoDesembolsoEdit = productoDesembolso;
    this.verDetalle = true;
  }

  editar( productoDesembolso: ProductoDesembolso ) {
    this.rangosMontosAprobados = [];
    this.productoDesembolsoEdit = productoDesembolso;
    this.verDetalle = false;
    this.productosDesembolsos.forEach( x => {
      if ( !productoDesembolso.idProductoDesembolso || x.idProductoDesembolso !== productoDesembolso.idProductoDesembolso ) {
        this.rangosMontosAprobados.push( {
          maximo: x.rangoMontoAprobadoMaximo,
          minimo: x.rangoMontoAprobadoMinimo
        } );
      }
    } );
    this.editarProductoDesembolso = true;
  }

  ocultarDetalle( b ) {
    this.productoDesembolsoEdit = null;
    this.verDetalle = false;
    this.editarProductoDesembolso = false;
    if ( b ) {
      // Refrescar el datatable
      this.productoDesembolsoService.listadoPorProducto( this.producto.idProducto ).subscribe( res => {
        this.productosDesembolsos = res;
        this.carTabla = false;
      } );
    }
  }
}
